import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "list-wrapper" }
const _hoisted_2 = { class: "list-columns" }
const _hoisted_3 = { class: "list-columns-grid has-button" }
const _hoisted_4 = {
  key: 2,
  class: "empty-placeholder"
}
const _hoisted_5 = {
  key: 3,
  class: "empty-placeholder"
}
const _hoisted_6 = { class: "list-columns-grid" }
const _hoisted_7 = {
  key: 2,
  class: "empty-placeholder"
}
const _hoisted_8 = {
  key: 3,
  class: "empty-placeholder"
}

import VitaBeruCard from "@/components/VitaBeruCard.vue";
import VitaBeruCreateModal from "@/components/VitaBeruCreateModal.vue";
import VitaBeruDetailModal from "@/components/VitaBeruDetailModal.vue";
import VitaEmptyPlaceholder from "@/components/UI/VitaEmptyPlaceholder.vue";
import { onMounted, ref } from "vue";
import {
  PerfectScrollbar,
  PerfectScrollbarExpose,
} from "vue3-perfect-scrollbar";
import VitaButton from "./UI/VitaButton.vue";
import { BeruCardFree, BeruCardTaken } from "@/types/beru";
import { useBeruExchange } from "@/composables/useBeruExchange";
import VitaLoaderSpinner from "./UI/VitaLoaderSpinner.vue";
import { reachGoal } from "@/utils/metrika";


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaBeruLayout',
  setup(__props) {

const isModalOpen = ref(false);
const isCreateModalOpen = ref(false);
const selectedCard = ref<BeruCardFree | BeruCardTaken | null>(null);
const freeScrollRef = ref<PerfectScrollbarExpose | null>(null);
const takenScrollRef = ref<PerfectScrollbarExpose | null>(null);

const scrollOptions = {
  minScrollbarLength: 60,
  wheelPropagation: false,
  suppressScrollX: true,
};

const openModal = (item: BeruCardFree | BeruCardTaken) => {
  selectedCard.value = item;
  isModalOpen.value = true;
};

// Свободные смены по Беру
const {
  error: hasExchangeFreeError,
  isLoading: isExchangeFreeLoading,
  showLoaderMore: showLoaderMoreFree,
  hasLoadMoreError: hasLoadMoreFreeError,
  data: exchangeFree,
  fetchInitial: getBeruExchangeFree,
} = useBeruExchange(
  "beru/getFreeBeru",
  "beru/exchangeFree",
  "beru/exchangeFreeMeta",
  () => freeScrollRef.value?.ps?.element ?? null,
);

// Взятые смены по Беру
const {
  error: hasExchangeTakenError,
  isLoading: isExchangeTakenLoading,
  showLoaderMore: showLoaderMoreTaken,
  hasLoadMoreError: hasLoadMoreTakenError,
  data: exchangeTaken,
  fetchInitial: getBeruExchangeTaken,
} = useBeruExchange(
  "beru/getTakenBeru",
  "beru/exchangeTaken",
  "beru/exchangeTakenMeta",
  () => takenScrollRef.value?.ps?.element ?? null,
);

const getAllBeruExchange = () => {
  getBeruExchangeFree();
  getBeruExchangeTaken();
}

const onCreateBeruClick = () => {
  isCreateModalOpen.value = true
  reachGoal('beru-create-click')
}

onMounted(() => {
  getAllBeruExchange();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "list-header" }, [
        _createElementVNode("div", null, "Свободные"),
        _createElementVNode("div", null, "Взятые")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          (
            (_unref(isExchangeFreeLoading) && !_unref(hasExchangeFreeError)) ||
            _unref(showLoaderMoreFree)
          )
            ? (_openBlock(), _createBlock(VitaLoaderSpinner, { key: 0 }))
            : (
            !_unref(hasLoadMoreFreeError) &&
            !_unref(isExchangeFreeLoading) &&
            _unref(exchangeFree) &&
            _unref(exchangeFree).length > 0
          )
              ? (_openBlock(), _createBlock(_unref(PerfectScrollbar), {
                  key: 1,
                  ref_key: "freeScrollRef",
                  ref: freeScrollRef,
                  class: "list-columns-scroll rail-beru rail-thin rail-lightgray",
                  options: scrollOptions
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(exchangeFree), (item, idx) => {
                        return (_openBlock(), _createBlock(VitaBeruCard, {
                          key: idx,
                          card: item,
                          onClick: ($event: any) => (openModal(item)),
                          "data-qa": "beru-layout-card-free-open"
                        }, null, 8, ["card", "onClick"]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 512))
              : (_unref(hasLoadMoreFreeError) || _unref(hasExchangeFreeError))
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(VitaEmptyPlaceholder, {
                      "qa-name": "beru-free-error",
                      icon: "isOffline",
                      message: _unref(hasExchangeFreeError),
                      description: "При загрузке данных произошла ошибка. Попробуйте обновить страницу позже.",
                      "icon-width": "100",
                      "icon-height": "100",
                      "on-refresh-click": _unref(getBeruExchangeFree)
                    }, null, 8, ["message", "on-refresh-click"])
                  ]))
                : (_unref(exchangeFree) && _unref(exchangeFree).length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(VitaEmptyPlaceholder, {
                        "qa-name": "beru-free-empty",
                        icon: "isEmptyWindow",
                        message: "Пока нет ни одной свободной потребности",
                        description: "Создайте новую потребность",
                        "icon-width": "100",
                        "icon-height": "100"
                      })
                    ]))
                  : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          (
            (_unref(isExchangeTakenLoading) && !_unref(hasExchangeTakenError)) ||
            _unref(showLoaderMoreTaken)
          )
            ? (_openBlock(), _createBlock(VitaLoaderSpinner, { key: 0 }))
            : (
            !_unref(hasLoadMoreTakenError) &&
            !_unref(isExchangeTakenLoading) &&
            _unref(exchangeTaken) &&
            _unref(exchangeTaken).length > 0
          )
              ? (_openBlock(), _createBlock(_unref(PerfectScrollbar), {
                  key: 1,
                  ref_key: "takenScrollRef",
                  ref: takenScrollRef,
                  class: "list-columns-scroll rail-beru rail-thin rail-lightgray",
                  options: scrollOptions
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(exchangeTaken), (item, idx) => {
                        return (_openBlock(), _createBlock(VitaBeruCard, {
                          key: idx,
                          card: item,
                          onClick: ($event: any) => (openModal(item)),
                          "data-qa": "beru-layout-card-taken-open"
                        }, null, 8, ["card", "onClick"]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 512))
              : (_unref(hasExchangeTakenError) || _unref(hasLoadMoreTakenError))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(VitaEmptyPlaceholder, {
                      "qa-name": "beru-taken-error",
                      icon: "isOffline",
                      message: _unref(hasExchangeTakenError),
                      description: "При загрузке данных произошла ошибка. Попробуйте обновить страницу позже.",
                      "icon-width": "100",
                      "icon-height": "100",
                      "on-refresh-click": _unref(getBeruExchangeTaken)
                    }, null, 8, ["message", "on-refresh-click"])
                  ]))
                : (_unref(exchangeTaken) && _unref(exchangeTaken).length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(VitaEmptyPlaceholder, {
                        "qa-name": "beru-taken-empty",
                        icon: "isEmptyBox",
                        message: "Пока нет ни одной взятой потребности",
                        description: "Создайте новую потребность",
                        "icon-width": "100",
                        "icon-height": "100"
                      })
                    ]))
                  : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(VitaButton, {
        class: "list-btn-floating rounded no-shadow",
        color: "blue",
        width: "inline",
        onClick: onCreateBeruClick,
        "data-qa": "beru-layout-button-create"
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode(" Создать потребность Беру! ", -1)
        ]))]),
        _: 1
      })
    ]),
    _createVNode(VitaBeruDetailModal, {
      open: isModalOpen.value,
      card: selectedCard.value,
      onCanceled: getAllBeruExchange,
      onToggleInfoModal: _cache[0] || (_cache[0] = ($event: any) => (isModalOpen.value = false))
    }, null, 8, ["open", "card"]),
    _createVNode(VitaBeruCreateModal, {
      open: isCreateModalOpen.value,
      onToggleInfoModal: _cache[1] || (_cache[1] = ($event: any) => (isCreateModalOpen.value = false)),
      onCreated: _unref(getBeruExchangeFree)
    }, null, 8, ["open", "onCreated"])
  ], 64))
}
}

})